module.exports = __webpack_public_path__ + "static/media/signage-industrial-img26.12309263.jpg";